export default function ListEssayPage({user}){
    // TODO build this.
    return <>This is essay page</>;
}